import styled from "@emotion/styled";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/router-devtools";
import type { FC } from "react";
import type { AuthContextProps } from "react-oidc-context";
import { useAuth } from "react-oidc-context";

import { Navbar } from "@/components/Navbar/component";
import { SideBar } from "@/components/Sidebar/component";
import { SignIn } from "@/components/SignIn/component";
import { RoundedFullPage } from "@/layouts/common/RoundedFullPage/layout";
import { AuthorizationLayout } from "@/layouts/guards/authorization/layout";

interface RoundedFullPageWithShadowProps {
  "data-testid"?: string;
  className?: string;
}
const RoundedFullPageWithShadow = styled(
  RoundedFullPage,
)<RoundedFullPageWithShadowProps>`
  filter: drop-shadow(10px 10px 10px rgba(0, 0, 0, 0.7));
  overflow: hidden;
`;
const GradientBackground = styled.div`
  flex-grow: 1;
  display: flex;
  min-height: 100dvh;
  background: linear-gradient(#0ea3fb, #0077fb);
`;
const RootLayout: FC = () => {
  const auth = useAuth();

  return auth.user ? (
    <AuthorizationLayout>
      <>
        <GradientBackground>
          <SideBar />
          <RoundedFullPageWithShadow data-testid='rounded-full-page-with-shadow'>
            <>
              <Navbar />
              <Outlet />
            </>
          </RoundedFullPageWithShadow>
        </GradientBackground>
        <TanStackRouterDevtools />
      </>
    </AuthorizationLayout>
  ) : (
    <SignIn />
  );
};

interface MyRouterContext {
  auth: AuthContextProps;
  roles: string[];
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
  component: RootLayout,
});
